export const SECTORS = [
  { value: 'technology', label: 'Technology & IT Services' },
  { value: 'healthcare', label: 'Healthcare & Medical Services' },
  { value: 'finance', label: 'Finance & Banking' },
  { value: 'retail', label: 'Retail & E-commerce' },
  { value: 'manufacturing', label: 'Manufacturing & Industrial' },
  { value: 'education', label: 'Education & Training' },
  { value: 'energy', label: 'Energy & Utilities' },
  { value: 'logistics', label: 'Logistics & Transportation' },
  { value: 'telecommunications', label: 'Telecommunications' },
  { value: 'government', label: 'Government & Public Sector' },
  { value: 'agriculture', label: 'Agriculture & Food Production' },
  { value: 'construction', label: 'Construction & Real Estate' },
  { value: 'hospitality', label: 'Hospitality & Tourism' },
  { value: 'media', label: 'Media & Entertainment' },
  { value: 'legal', label: 'Legal Services' },
  { value: 'consulting', label: 'Consulting & Professional Services' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'pharmaceutical', label: 'Pharmaceutical & Biotechnology' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'aerospace', label: 'Aerospace & Defense' },
  { value: 'mining', label: 'Mining & Natural Resources' },
  { value: 'nonprofit', label: 'Non-Profit & NGO' },
  { value: 'research', label: 'Research & Development' },
  { value: 'security', label: 'Security Services' },
];

export const INDUSTRIES = [
  { value: 'private', label: 'Private Sector' },
  { value: 'government', label: 'Government' },
  { value: 'public', label: 'Public Sector' },
  { value: 'ngo', label: 'NGO / Non-Profit' },
  { value: 'academic', label: 'Academic / Research' },
  { value: 'international', label: 'International Organization' },
  { value: 'military', label: 'Military / Defense' },
  { value: 'hybrid', label: 'Public-Private Partnership' },
];

export const PASSWORD_MIN_LENGTH = 8;
export const USERNAME_MIN_LENGTH = 3;
export const ORG_NAME_MIN_LENGTH = 2;
